/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useNavigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

import { getShipment, getShipmentAsGuestUser } from "api/services/shipment";
import errorToast from "helpers/errorToast";
import { shipmentQueryKeys } from "./shipmentQueryKeys";

export const useGetShipmentDetails = (
  shipmentId: string,
  updateNotificationSetting: boolean = false,
  options?: UseQueryOptions & { hideError?: boolean },
) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const queryClient = useQueryClient();
  const intl = useIntl();

  const queryRes = useQuery<any>({
    queryKey: shipmentQueryKeys.shipmentDetails(shipmentId),
    queryFn: getShipmentDetails,
    ...options,
  });

  function getShipmentDetails() {
    const getFn = Cookies.get("is_guest") === "true" ? getShipmentAsGuestUser : getShipment;
    return getFn(shipmentId)
      .then((response) => {
        if (updateNotificationSetting) updateNotificationEnabledSetting(response.data?.settings?.notification_enabled);
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        if (err?.response?.status === 403 && pathname === `/shipment/${shipmentId}/tracking`) {
          navigate(`/shipment/${shipmentId}`, { replace: true });
        } else if (err?.response?.status !== 403 && !options?.hideError) {
          errorToast(
            err,
            intl.formatMessage({
              id: "tracking.couldNotRetrieveTrackingProgress",
              defaultMessage: "Could not retrieve tracking progress. Please try again later.",
            }),
          );
        }
        return Promise.reject(err);
      });
  }

  const updateNotificationEnabledSetting = (notificationEnabled: boolean) => {
    queryClient.setQueryData(shipmentQueryKeys.shipmentBasicDetails(shipmentId), (prevData: any) => {
      if (!prevData) {
        return undefined;
      }
      return {
        ...prevData,
        settings: {
          ...prevData.settings,
          notification_enabled: notificationEnabled,
        },
      };
    });
  };

  return queryRes;
};
